import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { SUBMISSION_KEYS } from './queryKeys';

/**
 * Raw submission values, for client-side per-field drill-downs (e.g. "who answered X").
 * Capped at 200 submissions — see forms-backend-requests.md. `enabled` defers the
 * fetch until a drill-down dialog actually opens, since this is an N+1 request.
 */
export function useSubmissionRawValues(formId: string, enabled: boolean) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: SUBMISSION_KEYS.stats(orgId ?? '', formId),
    queryFn: ({ signal }) => formsService.getSubmissionsForStats(formId, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!formId && enabled,
  });

  return {
    submissions: data?.data ?? [],
    isLoading,
    isError,
  };
}
